// extracted by mini-css-extract-plugin
export default {"root":"popup-message_root__7rYLN","apparition":"popup-message_apparition__ADZ3V"};